import Modal from 'metrics/components/Common/Modal/Modal';
import React from 'react';

const ModalTest = (props: any) => {
    return <Modal title="PAU">testing</Modal>;
};
export default ModalTest;
